<template>
  <v-container :style="{ marginTop: $vuetify.breakpoint.xs ? '5vh' : '' }">
      <v-row justify="center" class="mt-4">
        <v-col cols="12" md="9" :order="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? 'last' : 'first'">
          <v-container class="editor">
            <v-form class="form-blog-post">
              <v-col cols="12">
                <v-alert
                    v-model="alert"
                    prominent
                    type="error"
                    close-text="Close Alert"
                    :color="alertColor"
                    outlined
                    dismissible
                    text
                >
                  {{ alertMsg }}
                </v-alert>
              </v-col>
              <v-text-field
                  v-model="contentTitle"
                  :disabled="loading"
                  color="primary"
                  hint="Try to be so descriptive as possible"
                  label="title"
                  name="Title"
                  outlined
                  placeholder="e.g how to integrate trigonometric functions."
                  small
                  counter
                  maxlength="50"
              />
              <v-select
                  v-model="selectGrade"
                  :items="blogGrades"
                  item-text="grade"
                  item-value="id"
                  label="Select Grade"
                  persistent-hint
                  return-object
                  single-line
                  solo
              ></v-select>
              <v-card class="rounded-0 mb-9 card-color" flat>
                <v-hover v-slot="{ hover }">
                  <v-img v-if="!showClipDialog" :src="imagePreviewURL" class="rounded-lg cover-image">
                    <v-card-title
                        class="justify-center fill-height fill-width"
                        primary-title
                    >
                      <v-btn
                          v-if="hover || !imagePreviewURL"
                          :loading="isSelecting"
                          class="text-none cover-image-btn"
                          color="primary"
                          depressed
                          rounded
                          @click="onButtonClick"
                      >
                        <v-icon left> mdi-cloud-upload</v-icon>
                        {{ imagePreviewURL ? buttonTextChangeImage : buttonTextUploadImage }}
                      </v-btn>
                      <input
                          ref="uploader"
                          accept="image/*"
                          class="d-none"
                          type="file"
                          @change="onFileChanged"
                      />
                    </v-card-title>
                  </v-img>
                </v-hover>
              </v-card>
              <v-combobox
                  v-model="blogTags"
                  :disabled="loading"
                  :items="tags"
                  :search-input.sync="search"
                  chips
                  deletable-chips
                  item-text="name"
                  item-value="id"
                  label="Tags"
                  multiple
                  outlined
                  return-object
              >
                <template v-slot:[`item.name`]="{ item }">
                  <div class="p-2">
                    {{ item.name }}
                  </div>
                </template>
                <template v-slot:append-item="">
                  <div v-intersect="endIntersect">
                  </div>
                </template>
              </v-combobox>
              <label for="Description">Description</label>
              <quill-editor
                  id="Description"
                  ref="blogQuillEditor"
                  v-model="content"
                  :disabled="loading"
                  :options="editorOptions"
                  height="500px"
                  label="Description"
                  placeholder="Start typing your educational blog post"
              />
            </v-form>
            <v-card-actions>
              <v-btn
                  :disabled="$v.$invalid || loading"
                  :loading="loading"
                  class="btn-text save-blog-btn"
                  color="primary"
                  width="10.150rem"
                  @click="saveBlogPost()"
              >
                {{ isEditingOldBlog ? "Save" : "Create" }}
              </v-btn>
            </v-card-actions>
          </v-container>
        </v-col>
        <v-col justify="center" cols="12" md="3">
          <v-card
              :style="{backgroundColor: $vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '#f5f6f8' : 'white'}"
              :elevation="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? 0 : 1"
              class="mt-md-7 mt-lg-7 d-flex flex-column justify-center"
          >
            <div class="text-center font-weight-bold text-h6 mt-md-2 mt-lg-2 mt-xl-2">Content checker</div>
            <div class="text-center mt-5 mx-1">
              <v-progress-linear
                  v-if="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm"
                  :rotate="90"
                  :size="100"
                  :width="15"
                  height="25"
                  :value="checkPercentage"
                  color="#0033AA"
              >
                <template v-slot:default="{ value }">
                  <strong>{{ Math.ceil(value) }}%</strong>
                </template>
              </v-progress-linear>
              <v-progress-circular
                  v-else
                  :rotate="90"
                  :size="100"
                  :width="15"
                  :value="checkPercentage"
                  color="#0033AA"
                  justify="center"
              >
                {{checkPercentage}}
              </v-progress-circular>
            </div>
            <v-card-text>
              <v-list v-if="!($vuetify.breakpoint.xs || $vuetify.breakpoint.sm)">
                <template v-for="item in checks " >
                  <v-divider :key="`${item.title}-${item.id}`" />
                  <v-list-item :key="item.title">
                    <v-list-item-icon>
                      <v-icon v-if="item.check" color="#0033AA">mdi-check-circle-outline</v-icon>
                      <v-icon v-else color="red">mdi-close-circle-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>{{item.title}}</v-list-item-title>
                      <v-list-item-subtitle>{{item.subtitle}}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-list>

              <div v-else class="d-flex flex-row justify-space-around">
                <template v-for="(item, index) in checks">
                  <v-divider vertical :key="item.id" v-if="index !== 0" />
                  <div :key="item.title" class="d-flex flex-column">
                    <v-icon v-if="item.check" color="#0033AA">mdi-check-circle-outline</v-icon>
                    <v-icon v-else color="red">mdi-close-circle-outline</v-icon>
                    <div>{{item.title}}</div>
                  </div>
                </template>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-dialog :value="showClipDialog" max-width="600px" @click:outside="showClipDialog = false">
        <clipper-basic
            ref="clipper"
            :init-height="50"
            :init-width="50"
            :src="imageClipURL"
            bg-color="#0033AA"
            style="width: 100%; height: 100%"
        />
        <v-btn block color="primary" small @click="getClipResult">Clip Image</v-btn>
      </v-dialog>
    </v-container>
</template>

<script>
import {maxLength, required} from "vuelidate/lib/validators";
import IsAuthenticatedMixin from "@/mixins/IsAuthenticatedMixin";
import MentorMixin from "@/mixins/MentorMixin";
import {clipperBasic} from 'vuejs-clipper'
import { mapGetters } from 'vuex';

export default {
  mixins: [IsAuthenticatedMixin, MentorMixin],
  name: "ContentEditor",
  components: {clipperBasic},
  metaInfo() {
    return {
      title: "Guiomentor - Blog Editor",
      url: window.location.href
    };
  },
  data() {
    return {
      draftStatus: "DRAFT",
      countryCode: null,
      content: "",
      contentTitle: "",
      isEditingOldBlog: false,
      tags: [],
      tagsResponse: null,
      blogTags: [],
      blogGrades: [],
      blogGrade: null,
      blogTagsToPost: [],
      contentSlug: null,
      loading: false,
      search: "",
      saveButtonDisabled: false,
      editorOptions: {
        theme: "snow",
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            // Bold, italic, underline, strikethrough
            ["blockquote", "code-block"],
            // Reference, code block

            [{header: 1}, {header: 2}],
            // Title, the form of key-value pairs; 1, 2 represents the font size
            [{list: "ordered"}, {list: "bullet"}],
            // list
            [{script: "sub"}, {script: "super"}],
            // superscript and subscript
            [{indent: "-1"}, {indent: "+1"}],
            // indent
            [{direction: "rtl"}],
            // text direction

            [{size: ["small", false, "large", "huge"]}],
            // font size
            [{header: [1, 2, 3, 4, 5, 6, false]}],
            // Several levels of title

            [{color: []}, {background: []}],
            // font color, font background color
            [{font: []}],
            // font
            [{align: []}],
            // alignment

            ["clean"],
            // Clear font style
            ["image", "video"],
            // Upload pictures, upload videos
          ]
        },
      },
      initialFile: null,
      imageFile: null,
      imageClipURL: null,
      imagePreviewURL: null,
      buttonTextUploadImage: "Upload cover image",
      buttonTextChangeImage: "Change cover image",
      isSelecting: false,
      showClipDialog: false,
      selectGrade: {
        id: 0,
      },
      alert: false,
      alertMsg: '',
      alertColor: 'error'
    };
  },
  methods: {
    async getBlogGrades() {
      try {
        const blogGradeConfig = {
          method: 'get',
          url: `class_grade/?country_code=${this.countryCode}`
        }
        this.loading = true
        const blogGradesResponse = await this.axios(blogGradeConfig);
        this.blogGrades = blogGradesResponse.data.results;
        this.loading = false;
      } catch (error) {
        this.loading = false;
        if (error.message === 'Request failed with status code 404') {
          this.blogGrades = []
          this.alert = true
          this.alertMsg = "No grade levels for your selected country yet"
        } else {
          this.$snackbar.showMessage({
            content: error.message || this.$t("errors.somethingWentWrongError"),
            color: "error",
          });
        }
      }
    },
    async getTags(subUrl) {
      try {
        const blogTagsConfig = {
          method: "get",
          url: `blogs/tags/${subUrl}`,
        };
        this.loading = true;
        const blogTagsResponse = await this.axios(blogTagsConfig);
        this.tags = this.tags.concat(blogTagsResponse.data.results);
        this.tagsResponse = blogTagsResponse.data
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.$snackbar.showMessage({
          content: error.message || this.$t("errors.somethingWentWrongError"),
          color: "error",
        });
      }
    },
    getFormData(blogPostData) {
      return Object.entries(blogPostData).reduce(
          (formData, [formDataKey, formDataValue]) => {
            if (Array.isArray(formDataValue)) {
              formDataValue.forEach((arrayItem) => {
                formData.append(
                    formDataKey +
                    "[" +
                    formDataValue.indexOf(arrayItem) +
                    "]" +
                    "name",
                    arrayItem.name
                );
              });
            } else if (formDataKey === "grade_level") {
              formData.append(
                  formDataKey +
                  "." + "id",
                  formDataValue.id
              );
              formData.append(
                  formDataKey +
                  "." + "country",
                  formDataValue.country
              );
            } else {
              formData.append(formDataKey, formDataValue);
            }
            return formData;
          },
          new FormData()
      );
    },
    async saveBlogDraft() {
      if (this.contentTitle.length > 0) {
        let xformData = {};
        xformData.title = this.contentTitle ;
        xformData.body = this.content.length > 0 ? this.content : '...';
        xformData.grade_level = this.blogGrade == null ? { id: 2, country: this.countryCode } : this.blogGrade
        xformData.tags = this.blogTagsToPost.length > 0 ? this.blogTagsToPost : [{ name: 'EMPTY_TAG' }];
        xformData.status = this.draftStatus
        if (this.imageFile) {
          xformData.image = this.imageFile;
        }
        try {
          const blogPostConfig = {
            method: this.contentSlug ? "patch" : "post",
            url: this.contentSlug
              ? `blogs/posts/${this.contentSlug}/`
              : `blogs/posts/`,
            data: this.getFormData(xformData),
          };
          const blogPostResponse = await this.axios(blogPostConfig);
          this.contentSlug = blogPostResponse.data.slug;
          this.alertMsg = 'Blog draft auto saved successfully'
          this.alertColor = 'success',
            this.alert = true
        } catch (error) {
          this.alertMsg = 'Error auto saving blog draft, Select at least one tag'
          this.alertColor = 'error',
            this.alert = true
        }
      }

    },
    async saveBlogPost() {
      let xformData = {};
      xformData.title = this.contentTitle;
      xformData.body = this.content;
      xformData.grade_level = this.blogGrade
      xformData.tags = this.blogTagsToPost;
      if (this.imageFile) {
        xformData.image = this.imageFile;
      }
      try {
        this.loading = true;
        const blogPostConfig = {
          method: this.isEditingOldBlog ? "patch" : "post",
          url: this.isEditingOldBlog
              ? `blogs/posts/${this.contentSlug}/`
              : `blogs/posts/`,
          data: this.getFormData(xformData),
        };
        const blogPostResponse = await this.axios(blogPostConfig);
        const newSlug = blogPostResponse.data.slug;
        this.loading = false;
        this.$snackbar.showMessage({
          content: this.$t(this.isEditingOldBlog ? "Blog changes where submitted successfully" : "Blog was posted successfully"),
          color: "success",
        });
        this.$analytics.logEvent(this.isEditingOldBlog ? "edit_blog" : "create_blog", {
          user: this.user || "no logged in user",
          time: new Date(),
          url: window.location.href,
          version: "frontend version"
        });
        await this.$router.push(`/blogs/${newSlug}/`);
      } catch (error) {
        this.loading = false;
        this.$snackbar.showMessage({
          content: error.message || this.$t("errors.somethingWentWrongError"),
          color: "error",
        });
      }
    },
    async getBlogDraft(slug) {
      try {
        this.loading = true;
        const blogPostConfig = {
          method: "get",
          url: `blogs/posts/${slug}?format=json`,
        };

        const blogPostResponse = await this.axios(blogPostConfig);
        this.contentTitle = blogPostResponse.data.title === '...' ? '' : blogPostResponse.data.title ;
        this.content = blogPostResponse.data.body === '...' ? '' : blogPostResponse.data.body;
        this.blogTags = blogPostResponse.data.tags;
        this.selectGrade = blogPostResponse.data.grade_level
        this.imagePreviewURL = blogPostResponse.data.image;
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.$snackbar.showMessage({
          content: error.message || this.$t("errors.somethingWentWrongError"),
          color: "error",
        });
      }
    },
    onButtonClick() {
      this.isSelecting = true;
      window.addEventListener(
          "focus",
          () => {
            this.isSelecting = false;
          },
          {once: true}
      );
      this.$refs.uploader.click();
    },
    onFileChanged(e) {
      this.initialFile = e.target.files[0];
      this.imageClipURL = URL.createObjectURL(this.initialFile);
      this.showClipDialog = true
    },
    async getClipResult() {
      const canvas = this.$refs.clipper.clip();
      await canvas.toBlob((blob) => {
        this.imageFile = new File([blob], this.initialFile.name, {type: this.initialFile.type})
        this.showClipDialog = false
      }, this.initialFile.type);
    },
    endIntersect(entries, observer, isIntersecting) {
      if (isIntersecting && this.tagsResponse && this.tagsResponse.next && !this.loading) {
        const myArray = this.tagsResponse.next.split("blogs/tags/");
        this.getTags(myArray[1])
      } else if (entries[0].intersectionRatio === 0 && this.tagsResponse && this.tagsResponse.next && !this.loading) {
        const myArray = this.tagsResponse.next.split("blogs/tags/");
        this.getTags(myArray[1])
      }
    },
  },
  async created() {
    this.countryCode =
        this.user?.profile?.country == null || this?.user?.profile?.country?.length < 1 ? 'UG' :
        this.user.profile.country
    if (this.$route.fullPath.indexOf("create") === -1) {
      this.contentSlug = this.$route.params.slug;
      await this.getBlogDraft(this.contentSlug);
      this.isEditingOldBlog = true;
    }
    await this.getTags('');
    await this.getBlogGrades();
    const vm = this
    this.saveBlogDraftIntervalID = setInterval(function(){
          vm.saveBlogDraft()
        },
        120000
    );
  },
  validations: {
    blogTagsToPost: {required},
    contentTitle: {required, maxLength: maxLength(50)},
    content: {required},
    blogGrade: {required}
  },
  watch: {
    blogTags() {
      this.blogTagsToPost = this.blogTags.map((blogTag) => {
        if (typeof blogTag === "string") {
          return {name: blogTag};
        } else {
          return blogTag;
        }
      });
    },
    imageFile() {
      this.imagePreviewURL = URL.createObjectURL(this.imageFile);
    },
    selectGrade: {
      handler(newValue) {
        let vm = this
        vm.$nextTick(function() {
          vm.blogGrade = newValue
        })
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters({
      user: "auth/GET_USER",
    }),
    checks(){
      return [
        {id:0,title:"Title",subtitle:"20 characters and more",check: Boolean(this.contentTitle.length>19)},
        {id:1,title:"Tags",subtitle:"",check: Boolean(this.blogTags.length>0)},
        {id:2,title:"Grades",subtitle:"",check: Boolean(this.blogGrade)},
        {id:3,title:"Content body",subtitle:"",check: Boolean(this.content) }
      ]
    },
    checkPercentage(){
      let title = this.contentTitle.length > 19 ? 1:0
      let body = this.content ? 1 :0
      let tags = this.blogTags.length > 0 ? 1 : 0
      let grades = this.blogGrade ? 1 : 0
      return ((title + body + tags + grades ) / 4 )*100
    }
  },
  destroyed () {
    clearInterval(this.saveBlogDraftIntervalID);
  }
};
</script>

<style scoped>
.v-btn {
  text-transform: none !important;
}

.js-clipper-basic >>> .vuejs-clipper-basic__zoom-area {
  max-height: 170px !important;
  min-height: 150px !important;
  min-width: 80% !important;
}

.cover-image {
  z-index: 0
}

.cover-image-btn {
  z-index: 9999
}

.save-blog-btn {
  margin-top: 1em;
  color: #fff;
}

.form-blog-post {
  min-height: 28.125rem
}

.card-color {
  background-color: rgba(44, 42, 42, 0.2) !important;
  border-color: white !important;
}
</style>
